import store from "../../store";
import { romeApi } from "./rome-api";
import Vue from 'vue';
import VueRouter from 'vue-router';
const router = new VueRouter();

var lastActivity = Date.now();

pauseTrackingWhenIdle();

const metricsService = {
    _metrics: {},
    _suspended: [],

    start(type, target, component = null) {
        if(!isLoggedInInternalUser()) return;
        var options = { trackKeyStrokes: false, component }
        var name = target;

        if(_.isObject(target) && target.$options) {
            name = target.$options._componentTag;
            options.component = target;
        }

        if(options.component) options.trackKeyStrokes = true;
        
        var key = getKey(type, name);
        if(!this._metrics[key])
            this._metrics[key] = new MetricsTimer(type, name, options);

        var metric = this._metrics[key]
        metric.start();
        return metric;
    },

    stop(type, name) {
        if(!isLoggedInInternalUser()) return;
        if(!name) return;
        var key = getKey(type, name);
        if(!this._metrics[key]) return;

        var metric = this._metrics[key];
        metric.stop();
        return metric;
    },

    suspendActive(reason = '') {
        if(!isLoggedInInternalUser()) return;
        
        foreachMetric((key, metric) => {
            if(metric.stillActive) {
                metric.stop();
                this._suspended.push({ key, metric, reason });
            }
        });
    },

    resumeSuspended(reason = '') {
        if(!isLoggedInInternalUser()) return;

        this._suspended.filter(p => p.reason == reason)
            .forEach(p => {
                this._metrics[p.key] = p.metric;
                p.metric.reset();
            });

        _.remove(this._suspended, { reason });
    },

    idle(isIdle) {
        if(!isLoggedInInternalUser()) return;
        
        if(isIdle)
            this.suspendActive('idle');
        else
            this.resumeSuspended('idle');
    },

    sendToServer() {
        if(!isLoggedInInternalUser()) return;
        
        var dtos = Object.values(this._metrics)
        .map(metric => {
            var stillActive = metric.stillActive;

            let result = {
                type: metric.type,
                name: metric.name,
                activeTime: stillActive ? getActiveTimeSoFar(metric) : metric.activeTime,
                keystrokes: metric.keystrokes
            }

            if(stillActive)
                metric.reset();
            
            return result;
        });

        this._metrics = removeStoppedMetrics(this._metrics);

        if(!dtos.length) return;
        
        romeApi.post(`user/${store.getters['session/userId']}/spa-metrics`, dtos);

        function removeStoppedMetrics(metrics) {
            return _.pickBy(metrics, metric => !metric.stopped);
        }
    },

    handleRouteChange(to, from) {
        if(!isLoggedInInternalUser()) return;
        var toTemplate = routeTemplate(to);
        var fromTemplate = routeTemplate(from);

        if(toTemplate != fromTemplate) {
            this.stop('route', fromTemplate);

            if(toTemplate) {
                this.start('route', toTemplate);
            }
        }
        
        function routeTemplate(route) {
            var matched = getRouteMatch(route);
            if(!matched) return null;

            return matched.path;
        }
        
        function getRouteMatch(route) {
            if(!route) return null;
            if(!route.matched || !route.matched.length) return null;

            return route.matched[0];
        }
    }
}

class MetricsTimer {
    name = "";
    type = "";
    component = null;
    startTime = Date.now();
    activeTime = 0;
    stopped = false;
    keystrokes = 0;
    options = null;
    element = null;

    get stillActive() { return !this.stopped; }

    constructor(type, name, options) {
        this.type = type;
        this.name = name;
        this.component = options.component;
        this.options = options;

        if(this.component) {
            this.element = this.component.$vnode.elm;
        }    
    }

    setStartTime() {
        this.startTime = Date.now();
    }

    start() {
        this.addEventListeners();
        this.setStartTime();
        this.stopped = false;
    }

    stop() {
        this.calculateActiveTime();
        this.removeEventListeners();
        this.stopped = true;
    }

    reset() {
        this.stop();
        this.activeTime = 0;
        this.keystrokes = 0;
        this.start();
    }

    calculateActiveTime() {
        this.activeTime += ((Date.now() - this.startTime) / 1000);
    }

    addEventListeners() {
        if(this.options.trackKeyStrokes && this.element)
            this.element.addEventListener('keydown', this.onKeyPress.bind(this));
    }
    
    removeEventListeners() {
        if(this.options.trackKeyStrokes && this.element) {
            this.element.removeEventListener('keydown', this.onKeyPress.bind(this));
        }
    }

    onKeyPress() {
        this.keystrokes++;
    }
}

function pauseTrackingWhenIdle() {

    document.addEventListener('mousemove', handleUserInteraction);
    document.addEventListener('mousedown', handleUserInteraction);
    document.addEventListener('keydown', handleUserInteraction);
    document.addEventListener('visibilitychange', () => {
        var isIdle = !!document.hidden;
        metricsService.idle(isIdle);
    });

    setInterval(() => {
        var currentTime = Date.now();
        var diff = currentTime - lastActivity;
        if(diff > seconds(5)) metricsService.idle(true);
    }, seconds(5));

    function handleUserInteraction() {
        lastActivity = Date.now();
        metricsService.idle(false);
    }
}

function foreachMetric(callback) {
    Object.entries(metricsService._metrics).forEach(entry => {
        callback(entry[0], entry[1]);
    });
}

function isLoggedInInternalUser() {
    var loggedIn = store.getters['session/loggedIn'];
    var isInternalUser = store.getters['session/isInternalUser'];

    return loggedIn && isInternalUser;
}

function getActiveTimeSoFar(metric) {
    return ((Date.now() - metric.startTime) / 1000);
}

function minutes(num) {
    return num * 60 * 1000;
}

function seconds(num) {
    return num * 1000;
}

function getKey(type, name) {
    return `${type}-${name}`;
}

setInterval(function() { metricsService.sendToServer(); }, minutes(1));

export default metricsService;


// WEBPACK FOOTER //
// ./src/framework/utils/metrics-service.js